<template>
    <span class="popup-header font14 font-weight-regular">
        <span :class="[handicap == 0.0 ? 'dogTeam' : jw === $const.TEAM_HOME ? 'jollywhereTeam' : 'dogTeam']">
            {{ cthName }}
        </span>
        vs
        <span :class="[handicap == 0.0 ? 'dogTeam' : jw === $const.TEAM_AWAY ? 'jollywhereTeam' : 'dogTeam']">
            {{ ctaName }}
        </span>
    </span>
</template>

<script>
    export default {
        name: 'BetDialogEvent',
        props: {
            jw: {
                default: undefined,
                type: Number,
            },
            handicap: undefined,
            cthName: {
                default: undefined,
                type: String,
            },
            ctaName: {
                default: undefined,
                type: String,
            },
        },
    };
</script>
